import config from "../config";
import { showPromiseNotification, showUserNotification } from "./notification";
import { buildQueryParams, restAPIHandler } from "./restAPIService";
import { generateRandomPassword, copyToClipboard } from "./stringUtils";

const secretLifetimePeriods = {
    "14D": "14 Days",
    "7D": "7 Days",
    "3D": "3 Days",
    "1D": "1 Days",
    "12H": "12 Hours",
    "4H": "4 Hours",
    "1H": "1 Hour",
    "30M": "30 Minutes",
    "5M": "5 Minutes",
}

export {
    showPromiseNotification,
    showUserNotification,
    config,
    restAPIHandler,
    buildQueryParams,
    secretLifetimePeriods,
    generateRandomPassword,
    copyToClipboard
};
